export const queryKeys = {
  //Common api
  GET_ALL_CHANNEL_TYPE: "GET_ALL_CHANNEL_TYPE",
  GET_CHANNEL_TYPE_BY_ROLE: "GET_CHANNEL_TYPE_BY_ROLE",
  GET_CHANNEL_STATE: "GET_CHANNEL_STATE",
  GET_TRANSACTION_STATUS: "GET_TRANSACTION_STATUS",
  GET_CHANNEL_MANAGER_TIER_BY_TYPE: "GET_CHANNEL_MANAGER_TIER_BY_TYPE",
  GET_TIER_BY_TYPE: "GET_TIER_BY_TYPE",
  GET_ALL_MANAGER: "GET_ALL_MANAGER",
  GET_CHANNEL_NAME_CANCEL: "GET_CHANNEL_NAME_CANCEL",
  GET_CHANNEL_CODE_CANCEL: "GET_CHANNEL_CODE_CANCEL",
  GET_COMMISSION_PARENT_BY_CHANNEL_TIER:
    "GET_COMMISSION_PARENT_BY_CHANNEL_TIER",
  GET_CONFIG_API: "GET_CONFIG_API",
  GET_LIST_CHANNEL_NAME: "GET_LIST_CHANNEL_NAME",
  CHANNEL_PARENT_BY_TIER: "CHANNEL_PARENT_BY_TIER",
  CHANNEL_MANAGER_BY_TIER: "CHANNEL_MANAGER_BY_TIER",
  GET_CHANNEL_PARENT: "GET_CHANNEL_PARENT",
  GET_CHANNEL_PARENT_NAME: "GET_CHANNEL_PARENT_NAME",
  GET_CHANNEL_MANAGER: "GET_CHANNEL_MANAGER",
  GET_CHANNEL_MANAGER_NAME: "GET_CHANNEL_MANAGER_NAME",
  GET_CHANNEL_TIER: "GET_CHANNEL_TIER",
  GET_BUSINESS_STAFF: "GET_BUSINESS_STAFF",
  GET_REQUIRE_BANK: "GET_REQUIRE_BANK",

  CHANNEL_PARENT_CHILD_BY_TIER: "CHANNEL_PARENT_CHILD_BY_TIER",
  CHANNEL_MANAGER_CHILD_BY_TIER: "CHANNEL_MANAGER_CHILD_BY_TIER",
  GET_CHANNEL_MANAGER_TYPE_BY_USER: "GET_CHANNEL_MANAGER_TYPE_BY_USER",
  GET_CHANNEL_BY_TYPE_AND_USER: "GET_CHANNEL_BY_TYPE_AND_USER",
  CHANNEL_CONFIG: "CHANNEL_CONFIG",
  CHANNEL_PAPER_TYPE: "CHANNEL_PAPER_TYPE",
  GET_CHANNEL_BALANCE: "GET_CHANNEL_BALANCE",
  GET_CHANNEL_TRANSACTION: "GET_CHANNEL_TRANSACTION",
  GET_CHANNEL_COMMISSION: "GET_CHANNEL_COMMISSION",

  COUNTRY: "COUNTRY",
  BTS: "BTS",
  PROVINCE: "PROVINCE",
  DISTRICT: "DISTRICT",
  PRECINCT: "PRECINCT",
  BANK_NAME: "BANK_NAME",
  BANK_ACCOUNT: "BANK_ACCOUNT",
  GET_USER_BANK: "GET_USER_BANK",
  GET_BANK_ACCOUNT: "GET_BANK_ACCOUNT",
  GET_BANK: "GET_BANK",
  UPLOAD_FILE: "UPLOAD_FILE",
  GET_IMAGE_TYPES: "GET_IMAGE_TYPES",
  GEO_LOCATION: "GEOLOCATION",
  RECEIVER: "RECEIVER",

  //Channel
  OVERVIEW_CHANNEL_SEARCH: "OVERVIEW_CHANNEL_SEARCH",
  APPROVE_REQUEST_CHANNEL_LIST: "APPROVE_REQUEST_CHANNEL_LIST",
  REJECT_REGISTER_CHANNEL: "REJECT_REGISTER_CHANNEL",
  GET_DATA_CHANNEL_CURRENT: "GET_DATA_CHANNEL_CURRENT",
  GET_DATA_CHANNEL_AFTER: "GET_DATA_CHANNEL_AFTER",
  GET_DATA_FINANCE_CURRENT: "GET_DATA_FINANCE_CURRENT",
  GET_DATA_FINANCE_AFTER: "GET_DATA_FINANCE_AFTER",
  //Register channel approve
  CREATE_REQUEST_REGISTER: "CREATE_REQUEST_REGISTER",
  CREATE_WITHDRAW: "CREATE_WITHDRAW",
  EDIT_WITHDRAW: "EDIT_WITHDRAW",
  //Update channel approve
  GET_CHANNEL_BY_ID: "GET_CHANNEL_BY_ID",
  GET_HAS_REQUEST_UPDATE: "GET_HAS_REQUEST_UPDATE",
  //Cancel channel approve
  CANCEL_APPROVE_REQUEST_CHANNEL_LIST: "CANCEL_APPROVE_REQUEST_CHANNEL_LIST",
  //Manager Sys User
  LEVEL_CREATE_SYS_USER: "LEVEL_CREATE_USER",
  CHANNEL_NAME_CREATE_SYS_USER: "CHANNEL_NAME_CREATE_SYS_USER",
  CHANNEL_CODE_CREATE_SYS_USER: "CHANNEL_CODE_CREATE_SYS_USER",
  ROLES_CREATE_SYS_USER: "ROLES_CREATE_SYS_USER",
  ROLES_SEARCH_CREATE_SYS_USER: "ROLES_SEARCH_CREATE_SYS_USER",
  GET_MANAGE_SYS: "GET_MANAGE_SYS",
  GET_BRANCH_SYS_USER: "GET_BRANCH_SYS_USER",
  GET_DETAIL_SYS_USER: "GET_DETAIL_SYS_USER",
  GET_TOKEN_DETAIL_SYS_USER: "GET_TOKEN_DETAIL_SYS_USER",
  GET_TOKEN_ROLES_SYS_USER: "GET_TOKEN_ROLES_SYS_USER",
  SEARCH_USER_NAME: "SEARCH_USER_NAME",
  //Detail channel
  GET_DETAIL_CHANNEL: "GET_DETAIL_CHANNEL",
  GET_HISTORY_CHANNEL: "GET_HISTORY_CHANNEL",
  GET_FINANCE: "GET_FINANCE",
  SUBMIT_CHANNEL_APPROVE_REQUEST: "SUBMIT_CHANNEL_APPROVE_REQUEST",
  CHECK_LIMIT_E: "CHECK_LIMIT_E",
  //Report
  GET_LEVEL_TYPE: "GET_LEVEL_TYPE",
  GET_LEVEL_NAME: "GET_LEVEL_NAME",
  GET_BRANCH_TYPE_BY_LEVEL_NAME: "GET_BRANCH_TYPE_BY_LEVEL_NAME",
  GET_LEVEL_NAME_TYPE_BY_LEVEL: "GET_LEVEL_NAME_TYPE_BY_LEVEL",
  GET_STAFF_TYPE: "GET_STAFF_TYPE",
  GET_STAFF_NAME_TIER_BY_TYPE: "GET_STAFF_NAME_TIER_BY_TYPE",
  DETAIL_DEBIT_REQUEST_CHANNEL_LIST: "DETAIL_DEBIT_REQUEST_CHANNEL_LIST",
  GET_TRANS_TYPE: "GET_TRANS_TYPE",
  EXPORT_REPORT_CHANNEL: " EXPORT_REPORT_CHANNEL",
  REPORT_PERCENTAGE: "REPORT_PERCENTAGE",
  REPORT_PERCENTAGE_CHAR: "REPORT_PERCENTAGE_CHAR",
  GET_TOTAL_AMOUNT_TRANSACTION_PERCENTAGE:
    "GET_TOTAL_AMOUNT_TRANSACTION_PERCENTAGE",
  GET_CHANNEL_REPORT_LIST: "GET_CHANNEL_REPORT_LIST",
  GET_REPORT_CHANNEL_LIST: "GET_REPORT_CHANNEL_LIST",
  GET_OBJECT_CHANNEL: "GET_OBJECT_CHANNEL",
  GET_DEVELOPMENT_ACCOUNT: "GET_DEVELOPMENT_ACCOUNT",
  GET_REPORT_CHANNEL_DETAIL: "GET_REPORT_CHANNEL_DETAIL",
  DOWNLOAD_REPORT_CHANNEL: "DOWNLOAD_REPORT_CHANNEL",
  DOWNLOAD_REPORT_TOTAL_DEBIT: "DOWNLOAD_REPORT_TOTAL_DEBIT",
  DOWNLOAD_REPORT_DETAIL_DEBIT: "DOWNLOAD_REPORT_DETAIL_DEBIT",
  GET_TRANS_ACCOUNT: "GET_TRANS_ACCOUNT",
  REPORT_TOTAL_TRANS_BYACCOUNT: "REPORT_TOTAL_TRANS_BYACCOUNT",
  REPORT_COMMISSION_LIST: "REPORT_COMMISSION_LIST",
  REPORT_COMMISSION_GET_TOTAL_AMOUNT: "REPORT_COMMISSION_GET_TOTAL_AMOUNT",
  REPORT_COMMISSION_DETAIL: "REPORT_COMMISSION_DETAIL",
  REPORT_COMMISSION_LIST_CHANNEL: "REPORT_COMMISSION_LIST_CHANNEL",
  SEARCH_REPORT_PERCENTAGE: "SEARCH_REPORT_PERCENTAGE",
  //Auth
  CURRENT_ROLE: "CURRENT_ROLE",
  USER_LANGUAGE: "USER_LANGUAGE",
  //Funding
  GET_LIST_CLEAR_DEBIT: "GET_LIST_CLEAR_DEBIT",
  GET_DETAIL_CLEAR_DEBIT: "GET_DETAIL_CLEAR_DEBIT",
  //Cancel
  GET_HISTORY_INFO: "GET_HISTORY_INFO",
  GET_CHANNEL_INFO: "GET_CHANNEL_INFO",
  CANCEL_CHANNEL: "CANCEL_CHANNEL",
  //Deposit
  GET_LIST_DEPOSIT_REQUEST: "GET_LIST_DEPOSIT_REQUEST",
  GET_WITHDRAW_APPROVE: "GET_WITHDRAW_APPROVE",
  GET_WITHDRAW_REQUEST: "GET_WITHDRAW_REQUEST",

  //cashIn
  GET_CASHIN_BY_ID: "GET_CASHIN_BY_ID",
  GET_HISTORY_CASHIN: "GET_HISTORY_CASHIN",
  GET_LIST_CASH_IN_REQUEST: "GET_LIST_CASH_IN_REQUEST",
  GET_LIST_CASH_IN_APPROVE: "GET_LIST_CASH_IN_APPROVE",

  //bulk payment
  GET_RESULT_BULK_PAYMENT_DETAIL: "GET_RESULT_BULK_PAYMENT_DETAIL",
  GET_LIST_BULK_PAYMENT_REQUEST: "GET_LIST_BULK_PAYMENT_REQUEST",
  GET_LIST_BULK_PAYMENT_APPROVE: "GET_LIST_BULK_PAYMENT_APPROVE",

  // Withdraw
  GET_LIST_WITHDRAW_CREATE: "GET_LIST_WITHDRAW_CREATE",
  GET_LIST_WITHDRAW_APPROVE: "GET_LIST_WITHDRAW_APPROVE",
  GET_WITHDRAW_BY_ID: "GET_WITHDRAW_BY_ID",
  GET_CHANNEL_TYPE_BY_USER: "GET_CHANNEL_TYPE_BY_USER",
  GET_CHANNEL_TYPE: "GET_CHANNEL_TYPE",
  GET_CHANNEL_NAME: "GET_CHANNEL_NAME",
  GET_OTP: "GET_OTP",
  GET_CONFIG: "GET_CONFIG",
  GET_WITHDRAW_HISTORY: "GET_WITHDRAW_HISTORY",

  // Funding
  GET_LIST_FUNDING_REQUEST: "GET_LIST_FUNDING_REQUEST",
  GET_LIST_FUNDING_REVIEW: "GET_LIST_FUNDING_REVIEW",
  GET_LIST_FUNDING_APPROVE: "GET_LIST_FUNDING_APPROVE",
  GET_FUNDING_BY_ID: "GET_FUNDING_BY_ID",
  GET_CHANNEL_MODEL: "GET_CHANNEL_LINES",
  //Ultilities
  GET_LIST_TRANSACTION_HISTORY: "GET_LIST_TRANSACTION_HISTORY",
  GET_TRANSACTION_TYPE: "GET_TRANSACTION_TYPE",
  GET_TRANSTYPE_STAFF: "GET_TRANSTYPE_STAFF",
  //Payment
  PAYMENT_BATCH_IMPORT_FILE: "PAYMENT_BATCH_IMPORT_FILE",
  PAYMENT_BATCH_ADD_NEW: "PAYMENT_BATCH_ADD_NEW",
  PAYMENT_BATCH_ACCOUNT_INFO: "PAYMENT_BATCH_ACCOUNT_INFO",
  PAYMENT_BATCH_REQUEST_LIST: "PAYMENT_BATCH_REQUEST_LIST",
  PAYMENT_BATCH_DETAIL: "PAYMENT_BATCH_DETAIL",
  PAYMENT_BATCH_DETAIL_LIST: "PAYMENT_BATCH_DETAIL_LIST",
  PAYMENT_BATCH_CUSTOMER_BY_ROLE: "PAYMENT_BATCH_CUSTOMER_BY_ROLE",
  PAYMENT_BATCH_GET_FEE: "PAYMENT_BATCH_GET_FEE",
};
